/* global Swiper */

// Tab nav is rendered server-side (PHP render_callback) — already in the HTML
// source for SEO. This script only wires up interactions and initializes Swiper.

function initSliderTabs( container ) {
	if ( container.dataset.c1wTabsInit ) return;
	container.dataset.c1wTabsInit = '1';

	const config   = JSON.parse( container.dataset.swiperConfig || '{}' );
	const swiperEl = container.querySelector( '.swiper' );
	const tabs     = Array.from( container.querySelectorAll( '.c1w-slider-tabs__tab' ) );

	if ( ! swiperEl ) return;

	const swiperConfig = {
		slidesPerView : config.slidesPerView || 1,
		spaceBetween  : config.spaceBetween  || 0,
		loop          : config.loop          || false,
		allowTouchMove: true,
	};

	if ( config.navigation ) {
		swiperConfig.navigation = {
			nextEl : container.querySelector( '.swiper-button-next' ),
			prevEl : container.querySelector( '.swiper-button-prev' ),
		};
	}

	if ( config.pagination ) {
		swiperConfig.pagination = {
			el        : container.querySelector( '.swiper-pagination' ),
			clickable : true,
		};
	}

	if ( config.autoplay ) {
		swiperConfig.autoplay = {
			delay               : config.autoplayDelay || 5000,
			disableOnInteraction: false,
		};
	}

	function setActiveTab( index ) {
		tabs.forEach( ( tab, i ) => {
			tab.classList.toggle( 'is-active', i === index );
			tab.setAttribute( 'aria-selected', i === index ? 'true' : 'false' );
		} );
	}

	swiperConfig.on = {
		slideChange( swiper ) {
			setActiveTab( swiper.realIndex );
		},
	};

	const swiper = new Swiper( swiperEl, swiperConfig );

	tabs.forEach( ( tab ) => {
		tab.addEventListener( 'click', () => {
			swiper.slideTo( parseInt( tab.dataset.index, 10 ) );
		} );
	} );
}

function initAll() {
	document.querySelectorAll( '.c1w-slider-tabs' ).forEach( initSliderTabs );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initAll );
} else {
	initAll();
}

const observer = new MutationObserver( ( mutations ) => {
	mutations.forEach( ( mutation ) => {
		mutation.addedNodes.forEach( ( node ) => {
			if ( node.nodeType !== Node.ELEMENT_NODE ) return;
			if ( node.classList?.contains( 'c1w-slider-tabs' ) ) {
				initSliderTabs( node );
			}
			node.querySelectorAll?.( '.c1w-slider-tabs' ).forEach( initSliderTabs );
		} );
	} );
} );

observer.observe( document.body, { childList: true, subtree: true } );
